import type { TOC } from '@ember/component/template-only'
interface Signature {
  Element: HTMLUListElement
  Blocks: {
    default: []
  }
}
export const ActionMenu: TOC<Signature> = <template>
  <ul
    role="menu"
    class="my-px min-w-[10rem] divide-y divide-dusty-black-100 rounded-md border border-dusty-black-100 bg-white shadow-xl print:hidden"
    ...attributes
  >
    {{yield}}
  </ul>
</template>

export default ActionMenu
